/**
 * SLAT Pocket - kopsektionen pa startsidan.
 *
 * Startsidans kopformular ar ett vanligt HTML-formular som postar till /cart/add,
 * vilket laddar om sidan och skickar kunden till varukorgssidan. Den har modulen
 * tar over inskicket, lagger varan i varukorgen via AJAX och oppnar temats
 * kundvagnslada direkt - samma beteende som produktsidans kopknapp.
 */

const FORM_ID = 'spBuyForm';
const STANDARD_EVENTS_URL = 'https://cdn.shopify.com/storefront/standard-events.js';

function cartAddUrl() {
  return window.Theme?.routes?.cart_add_url || '/cart/add.js';
}

function cartUrl() {
  return window.Theme?.routes?.cart_url || '/cart';
}

/** Sektions-id:n som temat vill ha tillbaka renderade i svaret. */
function getCartSectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
    .map((element) => element.dataset.sectionId)
    .filter(Boolean);
}

async function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return false;

  await customElements.whenDefined('theme-drawer');

  if (typeof drawer.open === 'function') {
    drawer.open();
    return true;
  }

  return false;
}

async function handleSubmit(event) {
  event.preventDefault();

  const form = event.currentTarget;
  const button = form.querySelector('.sp-buy__btn');
  const originalLabel = button ? button.textContent : '';

  const formData = new FormData(form);
  if (!formData.get('quantity')) formData.set('quantity', '1');

  const sectionIds = getCartSectionIds();
  if (sectionIds.length) formData.set('sections', sectionIds.join(','));

  const quantity = Number(formData.get('quantity')) || 1;

  let events = null;
  let deferred = null;

  try {
    events = await import(STANDARD_EVENTS_URL);
    deferred = events.CartLinesUpdateEvent.createPromise();

    form.dispatchEvent(
      new events.CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(formData.get('id')), quantity }],
        promise: deferred.promise,
      })
    );
  } catch (error) {
    events = null;
    deferred = null;
    console.warn('[sp-home-buy] Kunde inte ladda standard events:', error);
  }

  if (button) {
    button.disabled = true;
    button.textContent = 'Lagger i varukorgen...';
  }

  try {
    const addResponse = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
      credentials: 'same-origin',
    });

    const addResult = await addResponse.json();

    if (addResult.status) {
      throw new Error(addResult.description || addResult.message || 'Kunde inte lagga i varukorgen');
    }

    if (events && deferred) {
      const cartResponse = await fetch(`${cartUrl()}.json`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      const cart = await cartResponse.json();

      deferred.resolve({
        cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'sp-home-buy',
          itemCount: quantity,
          sections: addResult.sections,
          didError: false,
        },
      });
    }

    const opened = await openCartDrawer();
    if (!opened) window.location.href = cartUrl();
  } catch (error) {
    console.error('[sp-home-buy]', error);
    deferred?.reject(error);

    // Sista utvag: lat webblasaren posta formularet som vanligt sa att kunden
    // aldrig fastnar med en knapp som inte gor nagot.
    form.removeEventListener('submit', handleSubmit);
    form.submit();
    return;
  } finally {
    if (button) {
      button.disabled = false;
      button.textContent = originalLabel;
    }
  }
}

function init() {
  const form = document.getElementById(FORM_ID);
  if (!form || form.dataset.spEnhanced === 'true') return;

  form.dataset.spEnhanced = 'true';
  form.addEventListener('submit', handleSubmit);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
